module.exports = __webpack_public_path__ + "img/cone.c739e518.svg";